import styled, { css } from 'styled-components';
import LabelStyle from '../Label/LabelStyle';
import { themeSpacing } from '../../utils';
export default styled.div `
  display: flex;
  flex-direction: ${({ horizontal }) => (horizontal ? 'row' : 'column')};
  ${({ horizontal }) => horizontal &&
    css `
      ${LabelStyle} {
        margin-right: ${themeSpacing(4)};
      }
    `}
`;
//# sourceMappingURL=RadioGroupStyle.js.map